import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment'
import { Rapportjornalier} from "../constant/rapportjournalier"
import { retry, catchError } from 'rxjs/operators'
import {Collect} from "../constant/collect";
import {Pointing} from "../constant/pointing";

@Injectable({
  providedIn: 'root'
})
export class RapportjornalierService {

  public apiUrl = environment.api;

  constructor(
    private httpClient: HttpClient
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json'
    })
  };

  /**
   * getRapportjornalier
   */
  public getRapportjornaliers(limit): Observable<Rapportjornalier> {
    return this.httpClient.get<Rapportjornalier>(
      this.apiUrl + 'rapportj/getAllRapportJ/'+limit,
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }
  public date_lendemain(){
    const today = new Date();
    const tomorrow = new Date();
    return tomorrow.setDate(today.getDate()+1);
  }

  /**
   * getRapportjornalierByEntreprise
   */
  public getRapportjornalierByEntreprise(data,limit): Observable<Rapportjornalier> {
    return this.httpClient.post<Rapportjornalier>(
      this.apiUrl + 'rapportj/getRapportJByEntreprise/'+limit,
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }



  public excel(data): Observable<Pointing> {
    return this.httpClient.post<Pointing>(
      this.apiUrl + 'rapportj/excel',
      JSON.stringify(data),
      this.httpOptions
    ).pipe(retry(1), catchError(this.handleError))
  }

  /**
   * deleteRapportjornalier
   */
  public deleteRapportjornalier(data): Observable<Rapportjornalier> {
    return this.httpClient.post<Rapportjornalier>(
      this.apiUrl + 'rapportj/deleteRapportJ',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  public getBetweenTwoDates(data): Observable<Rapportjornalier>{
    return this.httpClient.post<Rapportjornalier>(
      this.apiUrl + 'rapportj/betweenTwoDates',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  public getBetweenTwoDatesByEntreprise(data): Observable<Rapportjornalier> {
    return this.httpClient.post<Rapportjornalier>(
      this.apiUrl + 'rapportj/betweenTwoDatesByEntreprise',
      JSON.stringify(data),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }


  public supprimerPlusieursRapportjournalier(data):Observable<Rapportjornalier> {
    return this.httpClient.post<Rapportjornalier>(
      this.apiUrl + 'rapportj/supprimerPlusieurs',
      JSON.stringify({arrayRapportjornalier:data}),
      this.httpOptions
    )
      .pipe(retry(1), catchError(this.handleError))
  }

  // Error handling
  public handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(['Erreur HTTP', errorMessage]);
    return throwError(errorMessage);
  }
}
